import { testimonials } from "pages/constants";
import { useState } from "react";

export const Testimonials: React.FC = ({}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = Math.ceil(testimonials.length / 2);

  const TestimonialCard = ({ testimonial }) => (
    <div className="bg-white p-6 rounded-lg border border-black shadow-sm h-full flex flex-col">
      <div className="flex flex-col sm:flex-row items-start mb-4">
        {/* <img
          src={testimonial.image}
          alt=""
          className="w-12 h-12 rounded-full mb-4 sm:mb-0 sm:mr-4 flex-shrink-0"
        /> */}
        <p className=" text-sm flex-grow text-[#454444] tracking-[1px] leading-[30px]">{testimonial.text}</p>
      </div>
      <div className="mt-auto ml-auto">
        <p className="font-semibold text-gray-800">{testimonial.author}</p>
        <p className=" text-xs">{testimonial.title}</p>
      </div>
    </div>
  );

  return (
    <section className="py-16 ml-4  px-4 h-[800px] md:min-h-[1000px]" id="testimonials">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-2xl font-bold text-start  text-amber-500">They Talk About Me</h3>
        <hr className="border-2 border-black w-20 mb-12 mt-2 ml-1 rounded-sm" />
        <div className="relative m-10">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-300 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="w-full flex-shrink-0 px-4 flex text-[#454444] tracking-[1px] leading-[30px] flex-col md:flex-row md:space-x-6"
                >
                  <div className="w-full md:w-1/2 mb-6 md:mb-0">
                    <TestimonialCard testimonial={testimonial} />
                  </div>
                  {testimonials[index + 1] && (
                    <div className="w-full md:w-1/2 hidden md:block">
                      <TestimonialCard testimonial={testimonials[index + 1]} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="flex  justify-center mt-8 gap-2">
            {Array.from({ length: totalSlides }, (_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-4 h-4 rounded-full transition-colors ${
                  currentSlide === index ? "bg-amber-500" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
